import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import aiRouter from "./modules/ai";
import toolkitRouter from "./modules/toolkit";
import agentRouter from "./modules/agent";
import xhsRouter from "./modules/xhs";
import ownerRouter from "./modules/owner";
import operationRouter from "./modules/operation";
import kolRouter from "./modules/kol";
import { directPath, loginDirectPath, routeMap } from "@/core/data/ConstData";
import { Mutations } from "@/store/enums/StoreEnums";

const routes = [
    {
        path: "/",
        redirect: "/ai/chat",
        component: () => import("@/layout/default.vue"),
        children: [
            ...aiRouter,
            ...toolkitRouter,
            ...agentRouter,
            ...xhsRouter,
            ...ownerRouter,
            ...operationRouter,
            ...kolRouter
        ]
    },
    {
        path: "/auth/login",
        name: "sign-in",
        component: () => import("@/views/auth/signin.vue"),
        meta: {
            title: '智点萤火虫 - 登录',
        },
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
];


const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to,from) => {
    
    let path = to.path;
    if(!directPath.includes(path) && !path.startsWith('/help/xhs/auth')){
        let resourceCodeList = store.getters.resourceCodeList;
        const ROUTE_MAP = routeMap;

        let path = to.path
        if(path.startsWith("/ai/chat")){
            path = "/ai/chat"
        }
        let m = ROUTE_MAP[path];
        console.log('path: '+to.path+' m:'+m)
        if(m && resourceCodeList.length > 0){
            if(!resourceCodeList.includes(m)){
                // router.push({ path: '/ai/chat'});
                // return false
            }else{
                store.getters.resourceList.forEach((item) => {
                    if(m == item['code']){
                        store.commit(Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX, item['id']);
                    }
                })
            }
        }else if(!loginDirectPath.includes(path)){
            store.commit(Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX, '1');
        }else{
            store.commit(Mutations.SET_ACCOUNT_MENU_ACTIVE_INDEX, '1');
        }
    }

    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});
//
router.afterEach((to, from, failure) => {

})

export default router;